export function shortAddress(address: string) {
  if (address.length < 8) return address;
  if (address.toLocaleLowerCase().startsWith('0x'))
    return `${address.slice(0, 6)}...${address.slice(-4)}`;
  return `${address.slice(0, 4)}...${address.slice(-4)}`;
}

export function shortAddressName(name: string) {
  if (name.length <= 15) return name;
  const slicedName = name.slice(0, 12);
  return slicedName[slicedName.length - 1] === '.'
    ? `${slicedName.slice(0, -1)}...`
    : `${slicedName}...`;
}
